import { useEffect } from "react";
import { useMap } from "react-leaflet";
import "leaflet-ant-path";

const AnimatedAntPath = ({ positions, options }) => {
    const map = useMap();

    useEffect(() => {
        const antPath = window.L.polyline.antPath(positions, options);
        antPath.addTo(map);
        return () => {
            map.removeLayer(antPath);
        };
    }, [map, positions, options]);

    return null;
};

export default AnimatedAntPath;
